module.exports = __webpack_public_path__ + "static/media/box-number-score.1fc5fca2.png";